import {Pipe, PipeTransform} from '@angular/core';
import { replaceCitations } from '@core/utils';

@Pipe({
    name: 'replaceCitations',
    standalone: false
})
export class ReplaceCitations implements PipeTransform{
    transform(value: string): string {
        const message = replaceCitations(value).message;
        return message; 
    }
}
